export default {"src":"/_next/static/media/KMZ.36fc1bea.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};